import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { IFormDetailsResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";

export const fetchSurveyFormResponse = createServiceAsyncThunk<
  IFormDetailsResponse, // response type
  { formId: number; userId?: number } // params type
>(
  ACTION_NAMES.FETCH_SURVEY_FORM_RESPONSE,
  ({ formId, userId }) => surveyFormsService.getFormDetails(formId, userId),
  ERROR_MESSAGES.FETCH_SURVEY_FORM_RESPONSE_FAILURE
);

const surveyFormDetailsSlice = createGenericSlice<
  IFormDetailsResponse,
  { formId: number; userId?: number }
>(SLICE_NAMES.SURVEY_FORM_RESPONSE, fetchSurveyFormResponse);

export const {
  clearError: clearSurveyFormResponseError,
  clearSuccessMessage: clearSurveyFormResponseSuccess,
} = surveyFormDetailsSlice.actions;

export default surveyFormDetailsSlice.reducer;
